v
<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";
import TaxReturnTableInput from "@/components/accountants/tax_return/table/TaxReturnTableInput.vue";

export default {
  name: "TaxReturnSelfEmploymentSection",
  components: {TaxReturnTableInput, TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <tr>
        <th>
          <translate>Beschrijving</translate>
        </th>

        <th>
          <translate>Waarde</translate>
        </th>
      </tr>
    </template>

    <template v-slot:body>
      <tr>
        <td scope="row">
          Hebt u recht op zelfstandigenaftrek?
        </td>

        <td>
          <input type="checkbox"
                 v-model="data.right_self_employment_deduction"/>
        </td>
      </tr>

       <tr>
        <td scope="row">
          Niet-gerealiseerde zelfstandigenaftrek uit vorige jaren
        </td>

        <td>
          <TaxReturnTableInput v-model="data.self_employment_deduction_previous_years"
                               :resettable="false"/>
        </td>
      </tr>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>
